import React from "react";
import { Link } from "react-router-dom";

function FooterOne() {
  return (
    <footer className="printer-footer">
      <div className="container">
        <div className="row justify-content-between mt-4">
          {/* --- BRAND INFO --- */}
          <div className="col-md-6 col-xl-3">
            <div className="footer-widget">
              <div className="footer-logo">
                <Link to="/">
                  <img src="/assets/img/logo3.svg" alt="Printers Friendly" />
                </Link>
              </div>
            </div>
          </div>

          {/* --- QUICK LINKS --- */}
          <div className="col-md-6 col-xl-auto">
            <div className="footer-widget">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/return-policy">Return Policy</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* --- CUSTOMER SUPPORT --- */}
          <div className="col-md-6 col-xl-auto">
            <div className="footer-widget">
              <h4 className="footer-title">Customer Support</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/track-order">Order Tracking</Link>
                </li>
                <li>
                  <Link to="/return-order">Return & Exchange</Link>
                </li>
                <li>
                  <Link to="/contact">Help Center</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping Policy</Link>
                </li>
                <li>
                  <Link to="/cookie-policy">Cookie Policy</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* --- ADDRESS SECTION (Replacing Instagram Column) --- */}
          <div className="col-md-6 col-xl-auto">
            <div className="footer-widget">
              <h4 className="footer-title">Contact Details</h4>

              <ul className="contact-list">
                <li>
                  <i className="fa-solid fa-phone"></i> +1-425-330-4080
                </li>
                <li>
                  <i className="fa-solid fa-envelope"></i>{" "}
                  info@printersfriendly.com
                </li>
                <li>
                  <i className="fa-solid fa-location-dot"></i> 5707 E. 32nd
                  Street Lot 714, Yuma, AZ 85365
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* --- DISCLAIMER AREA --- */}
        <div className="disclaimer-box">
          <h5>
            <i className="fa-solid fa-circle-info"></i> Legal Notice
          </h5>
          <p>
            Printers Friendly is an independent online retailer. We are not
            affiliated with HP or any other printer brand. All trademarks and
            product names are the property of their respective owners. Products
            are sourced through authorized distributors and include applicable
            manufacturer warranties.
          </p>
        </div>
      </div>

      {/* --- FOOTER BOTTOM BAR --- */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Printers Friendly. All Rights Reserved.
        </p>
        <div className="payment-methods">
          <span>We Accept</span>
          <img src="/assets/img/payment-method.png" alt="payment icons" />
        </div>
      </div>

      {/* === INLINE STYLE === */}
      <style>{`
        .printer-footer{
          background:#0f0f0f;
          color:#d6d6d6;
          padding-top:60px;
        }

        .footer-badges{
          display:flex;
          justify-content:center;
          gap:20px;
          flex-wrap:wrap;
        }

        .badge{
          background:#1b1b1b;
          padding:12px 20px;
          border-radius:10px;
          display:flex;
          align-items:center;
          gap:12px;
          border:1px solid #262626;
        }

        .badge i{color:#00bcd4;font-size:20px;}

        .footer-widget{margin-bottom:30px;}

        .footer-title{
          font-size:18px;
          font-weight:600;
          margin-bottom:12px;
          color:#fff;
        }

        .footer-links li{
          list-style:none;
          margin-bottom:8px;
        }

        .footer-links a{
          color:#cfcfcf;
          text-decoration:none;
          transition:0.3s;
        }

        .footer-links a:hover{color:#00bcd4;}

        .contact-list li{
          list-style:none;
          margin-bottom:10px;
        }

        .contact-list i{margin-right:10px;color:#00bcd4;}

        .social-icons a{
          margin-right:10px;
          color:#aaa;
          font-size:18px;
          transition:.3s;
        }

        .social-icons a:hover{color:#00bcd4;}

        .disclaimer-box{
          background:white;
          padding:18px;
          margin-top:25px;
          border-radius:10px;
          font-size:14px;
          line-height:1.6;
          margin-bottom:30px;
        }

        .footer-bottom{
          background:#0066ff;
          color:white;
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding:14px 20px;
          flex-wrap:wrap;
        }

        .footer-bottom p{
          color:white;
          margin-top: 10px;
        }

        .payment-methods img{height:28px;margin-left:10px;}

      `}</style>
    </footer>
  );
}

export default FooterOne;
